/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable id-blacklist */
export enum ObjectTypeFieldDataType {
    String = 'string',
    Number = 'number',
    List = 'list',
    Boolean = 'boolean',
}
